import * as React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useDispatch } from 'react-redux'
import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/AddCircleOutline'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder'
import Box from '@material-ui/core/Box'
import MyFavoriteStyles from './myFavoriteStyles'
import { trackWidgetClick } from '../../../../helpers/trackWidgetClick'

export const MyFavoritesEmptyComponent = () => {
  const classes = MyFavoriteStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  return (
    <>
      <Box className={classes.noMatchesContainter}>
        <Typography variant="subtitle1">You have no favorites!</Typography>
        <Button
          variant="outlined"
          className={classes.addToFavoritesButton}
          onClick={() => {
            trackWidgetClick(dispatch, 'MyFavorites', 'Add to favorites')
            history.push('/apps?myAppsTab=forYou')
          }}
        >
          <AddIcon className={classes.goToAppsButtonIcon} />
          Add to favorites
        </Button>
        <Box className={classes.noMatchesIconText}>
          <Typography variant="subtitle2">Click the</Typography>
          <FavoriteBorderIcon className={classes.inTextIcon} />
          <Typography variant="subtitle2">
            icon next to any application
          </Typography>
        </Box>
        <Typography variant="subtitle2">
          to add it to your favorites list.
        </Typography>
      </Box>
    </>
  )
}
